import React from 'react';
import {Typography} from '@material-ui/core';
import {PrimaryButton, SecondaryButton} from '../common/StyledButtons';
import {isEmpty} from 'lodash/lang';
import {Grid} from '@material-ui/core';
import {postInstance, submitAnswer} from '../../api'; 
import {buildQueryString, formatQuizAnswersForBackend} from '../../utils/common';
import Box from '@material-ui/core/Box';

export function QuizStartMessage(quizDataDict, answers, userURLParams, onClick, quizId, history, language) {
    const {name, startMessage, questions} = quizDataDict;
    const noAnswers = Object.values(answers).every((item) => isEmpty(item));
    const handleStartOver = () => {
        history.push({
            pathname:`/quizzes/${quizId}/confirm`,
            state: {
                userURLParams: userURLParams,
                quizDataDict: quizDataDict,
                answers:answers,
                language: language
            }
        });
    }

    return (
        <div className='quiz-start-screen'>
            <Box mb={2} ml={-1}>
                {    
                    noAnswers ? (
                        <PrimaryButton onClick={onClick}>
                            {
                                language === 'fr' ? 'Début' : 'Start'
                            }
                        </PrimaryButton>
                    ) : (
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            <PrimaryButton onClick={onClick}>
                                {
                                    language === 'fr' ? 'Reprendre évaluation' : 'Resume Assessment'
                                }
                            </PrimaryButton>
                            <SecondaryButton onClick={handleStartOver}>
                                {
                                    language === 'fr'?  'Recommencer' : 'Start Over'
                                }
                            </SecondaryButton>
                        </Grid>
                    )
                }
            </Box>
            <Typography variant="h4" color="primary">
                {name}
            </Typography>
            <Typography variant="subtitle1" color="primary">{questions.length} Questions</Typography>
            {startMessage &&
                <div dangerouslySetInnerHTML={{__html: startMessage}}/>
            }
            
        </div>
    );
}